import axios from "axios";

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
  headers: { "Content-Type": "application/json" },
});

axiosClient.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("authToken"); // taking auth token from local Storage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    if (!error.response) {
      return Promise.reject(error);
    }

    if (error.response.status === 401) {
      axiosClient.post("/auth/login").then((response) => {
        if (response.status === 200) {
          window.location.href = response.data.spotifyRedirectUrl;
        }
      });

      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default axiosClient;
